import React from 'react'
import { Stack } from '@mui/material'
import { LockIcon } from 'lucide-react'
import { SectionLabel } from 'components/UI/SectionLabel'
import { FieldRow } from 'components/Fields/FieldRow'
import type { AuthFactor } from 'hooks/api/useAuthFactors'

interface SecurityInfoProps {
  factors: AuthFactor[]
  isLoading: boolean
  onOpen: () => void
}

const describeFactors = (factors: AuthFactor[]): string => {
  const verified = factors.filter(f => f.verified)
  if (verified.length === 0) return ''
  if (verified.length > 1) return 'On · 2 methods'
  return verified[0].type === 'totp' ? 'On · Authenticator app' : 'On · Text message'
}

/**
 * VRG-490 (D8) — a Security SECTION on the existing Profile page, not a new
 * route. One row, opening `TwoFactorDrawer` — same idiom as the Notifications
 * / Help rows below it on this page, and the same "one action, one row"
 * shape as `LoginInfo`'s Email/Password rows above it.
 */
export const SecurityInfo: React.FC<SecurityInfoProps> = ({ factors, isLoading, onOpen }) => {
  return (
    <Stack mb={4}>
      <SectionLabel>Security</SectionLabel>
      <Stack spacing={0}>
        <FieldRow
          label="Two-factor authentication"
          icon={<LockIcon size={20} strokeWidth={1.5} />}
          value={isLoading ? undefined : describeFactors(factors)}
          placeholder="Off"
          onClick={onOpen}
        />
      </Stack>
    </Stack>
  )
}
